import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class WeightGridCriteria extends BasicCriteria {
codes: string[];
}

